/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/header.config.json';

import { VApplication } from '../../../../application';
import { AppNavigatorService } from '../../../../AppNavigator';

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.AppNavigatorService') as AppNavigatorService;
};

export interface IHeaderNavContentMethods extends IPluginMethodMap {
  getHeaderNavContent(args: any): any;
}

export class HeaderNavContentService implements IAgentPlugin {
  readonly methods: IHeaderNavContentMethods;

  constructor() {
    this.methods = {
      getHeaderNavContent: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    let buttonItems = await this.getGetHeaderButton();
    console.log(`buttonItems::`, buttonItems);
    return buttonItems;
  }

  private async getGetHeaderButton() {
    let user = await getWhoamiSrv()?.whoAmI();
    console.log(`user role`, user);
    if (user?.whoami === 'purchaser') {
      return { ...(config?.loginButton || {}) };
    } else {
      return { ...(config?.buttonItem || {}) };
    }
  }
}
